import { Pipe, PipeTransform } from '@angular/core';
import { LangService } from '../services/lang.service';

@Pipe({
  name: 'translateWords'
})
export class TranslateWordsPipe implements PipeTransform {

  constructor(private lang: LangService) {}

  transform(str: string, idLang: number): string {
    return this.lang.translateWords(str, idLang)
  }

}
